import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { taskNames } from './study-redux-slice'; // Adjust path as needed
import Consent from '../set-up-and-debrief/Consent';
import MicCheck from '../set-up-and-debrief/mic-check';
import AudioRecorder from '../survey-tools/audio-recorder';
import RecallIntro from '../tasks/recall/recall-intro';
import RecallNegative from '../tasks/recall/recall-negative';
import RecallPositive from '../tasks/recall/recall-positive';
import EmotionScale from '../tasks/emotion-scales/Emotion_Scale';
import MentalStateInstructions from '../tasks/mental-state-scales/Instructions';
import RationalityScale from '../tasks/mental-state-scales/Rationality_Scale';
import SocialImpactScale from '../tasks/mental-state-scales/SocImpact_Scale';
import ValenceScale from '../tasks/mental-state-scales/Valence_Scale';
import ThinkAloudTask from "../tasks/think-aloud/think-aloud-task"
import AudiosQs from "../tasks/audio-qs/audio-qs"
import QuestionnaireInstructions from "../tasks/questionnaires/Instructions2"
import SocialInteraction from "../tasks/questionnaires/social-interaction"
import CesdDepression from "../tasks/questionnaires/cesd-depression"
import UCLALoneliness from "../tasks/questionnaires/ucla-loneliness"
import STAI from "../tasks/questionnaires/stai"
import Brooding from "../tasks/questionnaires/brooding"
import Demographics from "../tasks/demographics/demographics"
import Debrief from '../set-up-and-debrief/debrief';
import OpenScreen from "../set-up-and-debrief/open-screen"


function Study({ currentTask, recallType, mentalStateTaskOrder, currentMentalStateTask }) {
    let display;
    switch (currentTask) {
        case taskNames.openScreen: 
            display = <OpenScreen />
            break;

        case taskNames.consent:
            display = <Consent />;
            break;
        case taskNames.micCheck:
            display = <AudioRecorder><MicCheck /></AudioRecorder>; 
            break;
        case taskNames.recallIntro:
            display = <RecallIntro />;
            break;
        case taskNames.recallPos:
            display = <RecallPositive/>;
            break;
        case taskNames.recallNeg:
            display = <RecallNegative />;
            break;
        case taskNames.postInductEmotion:
            display = <EmotionScale instanceId="post-induction-emotion"/>;
            break;
        case taskNames.postInductMSInstructions:
            display = <MentalStateInstructions />;
            break;
        case taskNames.postInductValence:
            display = <ValenceScale instanceId="post-induction-valence"/>;
            break;
        case taskNames.postInductRationality:
            display = <RationalityScale instanceId="post-induction-rationality"/>;
            break;
        case taskNames.postInductSocImpact:
            display = <SocialImpactScale instanceId="post-induction-social-impact"/>;
            break;
        case taskNames.thinkAloud:
            display = <ThinkAloudTask />;
            break;
        case taskNames.postThinkEmotion:
            display = <EmotionScale instanceId="post-think-emotion"/>;
            break;
        case taskNames.postThinkMSInstructions:
            display = <MentalStateInstructions />;
            break;
        case taskNames.postThinkValence:
            display = <ValenceScale instanceId="post-think-valence"/>;
            break;
        case taskNames.postThinkRationality:
            display = <RationalityScale instanceId="post-think-rationality"/>;
            break;
        case taskNames.postThinkSocImpact:
            display = <SocialImpactScale instanceId="post-think-social-impact"/>;
            break;
        case taskNames.thinkAloud:
            display = <ThinkAloudTask />;
            break;
        case taskNames.AudiosQs:
            display = <AudiosQs />;
            break;
        case taskNames.QuestionnaireInstructions:
            display = <QuestionnaireInstructions />;
            break;
        case taskNames.SocialInteraction:
            display = <SocialInteraction />;
            break;
        case taskNames.CesdDepression:
            display = <CesdDepression />;
            break;
        case taskNames.UCLALoneliness:
            display = <UCLALoneliness />;
            break;
        case taskNames.STAI:
            display = <STAI />;
            break;
        case taskNames.Brooding:
            display = <Brooding />;
            break;
        case taskNames.Demographics:
            display = <Demographics />;
            break;
        default:
            display = <Debrief />;
            break;
    }

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [currentTask]);

    return display;
}

const mapStateToProps = (state) => {
    return {
        currentTask: state.study.taskOrder[state.study.currentTask],
    };
}

export default connect(mapStateToProps)(Study);
